import type { LogoModel, MediaModel } from "shared/types";

import { generateFileUrl } from "./serviceUtils/helpers";

export const getAvatar = (avatar?: LogoModel | null) =>
	avatar ? (typeof avatar === "string" ? avatar : generateFileUrl(avatar as MediaModel)) : null;
